<template>
  <a-modal width="80%" title="开立确认" :visible="modalShow" :maskClosable="false" :footer="null" @cancel="close">
    <a-spin :spinning="loading">
      <div class="table-common">
        <a-table size="middle" :columns="confirmColumns" :row-key="record => record.gldId" :data-source="tableData"
          :pagination="false" bordered :locale="{ emptyText: '暂无数据' }">
          <template slot="gldTAmt" slot-scope="text">{{ text | splitK }}</template>
          <template slot="exDat" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
          <template slot="startDate" slot-scope="text">{{ text | dateFormat('YYYY-mm-dd') }}</template>
          <template slot="operation" slot-scope="text,record">
            <a @click="openFile(record)">付款承诺函</a>
          </template>
        </a-table>
        <div style="margin-top:10px;">
          <a-checkbox v-model="isPromise">已阅读并同意以上承诺函</a-checkbox>
        </div>
        <div class="spaceCenter model-footer-btns">
          <a-button @click="close">返回</a-button>
          <a-button @click="modalOk" type="primary" :loading="modalLoad" :disabled="!isPromise">确认</a-button>
        </div>
      </div>
      <fileView :artcCntnt.sync="artcCntnt" ref="fileView" />
    </a-spin>
  </a-modal>
</template>

<script>
import { doConfirmGoldApi, getLetterofCommitment } from "@/api/gold.js";
import fileView from "./fileView"
export default {
  props: {
    confirmTableData: {
      type: Array,
      default() {
        return [];
      }
    },
    overdueRate: {
      type: [String, Number],
    }
  },
  name: "confirmModal",
  components: { fileView },
  data() {
    return {
      modalShow: false,
      confirmColumns: [
        {
          title: "祺信编号",
          dataIndex: "gldId",
          width: "90px",
          align: 'center'
        },
        {
          title: "接收方",
          dataIndex: "cstName",
          width: "90px",
          align: 'center'
        },
        {
          title: "祺信面额(元)",
          dataIndex: "gldTAmt",
          width: "90px",
          scopedSlots: { customRender: "gldTAmt" },
          align: 'center'
        },
        {
          title: "开立日期",
          dataIndex: "startDate",
          width: "90px",
          scopedSlots: { customRender: "startDate" },
          align: 'center'
        },
        {
          title: "到期日期",
          dataIndex: "exDat",
          width: "90px",
          scopedSlots: { customRender: "exDat" },
          align: 'center'
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "90px",
          scopedSlots: { customRender: "operation" },
          align: 'center'
        }
      ],
      tableData: [],
      isPromise: false,
      modalLoad: false,
      loading: false,
      artcCntnt: ""
    }
  },
  computed: {
  },
  created() { },
  mounted() { },
  methods: {
    open() {
      this.modalShow = true;
      this.tableData = this.confirmTableData;
    },
    close() {
      this.isPromise = false;
      this.modalLoad = false;
      this.loading = false
      this.modalShow = false;
    },
    modalOk(e) {
      this.modalLoad = true;
      let params = {
        selected: JSON.stringify(this.confirmTableData),
        overdueRateVal: String(this.overdueRate)
      };
      doConfirmGoldApi(params, true)
        .then((res) => {
          this.modalLoad = false;
          this.$emit("ok", res.data);
        })
        .catch((error) => {
          this.modalLoad = false;
          this.isPromise = false;
        })
    },
    openFile(row) {
      this.loading = true;
      const { cstName, gldTAmt, exDat, goldRcvblList, estbOrgCode, rcPtyOrgCode, fkcnhNo } = row;
      const params = {
        gldId: fkcnhNo, cstName, gldTAmt, exDat, rcPtyOrgCode, estbOrgCode, tenantId: this.$store.getters["home/getTenant"].tenantId, goldRcvblList: JSON.stringify(goldRcvblList),
        overdueRateVal: String(this.overdueRate)
      };
      getLetterofCommitment(params).then(res => {
        this.artcCntnt = res.data;
        this.$refs.fileView.open();
        this.loading = false;
      }).catch(err => {
        this.loading = false;
      });
    }
  },
  watch: {
    confirmTableData(newVal) {
      this.tableData = this.confirmTableData || [];
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/table-find-rcvb/confirm-modal.vue